import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TableRow } from './TableRow';
export const TableBody = (props) => {
    var _a;
    const { table, enableMultiRowSelection } = props, rest = __rest(props, ["table", "enableMultiRowSelection"]);
    const rightLeaves = table.getRightLeafColumns();
    const rightPinnedColumn = (_a = rightLeaves[0]) === null || _a === void 0 ? void 0 : _a.id;
    return (_jsx(_Fragment, { children: table.getRowModel().rows.map((row, index) => (_jsx(TableRow, Object.assign({ row, index, rightPinnedColumn, enableMultiRowSelection, isLastRow: index + 1 === table.getRowModel().rows.length }, rest), row.id))) }));
};
//# sourceMappingURL=TableBody.js.map